var map = {
	"./NFO-black.png": 42145,
	"./NFO-black.svg": 31153,
	"./NFO.png": 60571,
	"./all-black.png": 37991,
	"./all-black.svg": 42403,
	"./all.png": 14485,
	"./insta-redeem-black.png": 98494,
	"./insta-redeem-black.svg": 93424,
	"./insta-redeem.png": 41232,
	"./recommended-black.png": 77839,
	"./recommended-black.svg": 81267,
	"./recommended.png": 11213,
	"./tax-saver-black.png": 64657,
	"./tax-saver-black.svg": 94261,
	"./tax-saver.png": 87627,
	"./wishlist-black.png": 33577,
	"./wishlist.png": 38259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71972;